import React from "react";

const JobinformationMiniCard = ({ children }) => {
  return (
    <div className="flex items-center p-2 py-4 pr-16 border-b">
      {children}
    </div>
  );
};

export default JobinformationMiniCard;
